import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cityUniqueLabel',
    pure: false,
    standalone: false
})
export class CityUniqueLabelPipe implements PipeTransform {
  transform(inputList: any[], labelKey?: string): any[] {

    // TODO: deactivated temporarily
    return inputList;

    labelKey = labelKey ?? 'DisplayName';

    if (!inputList) {
      return [];
    }

    // Create a Map to store unique labels as keys
    const uniqueLabelsMap = new Map<string, any>();

    // Iterate through the input list
    for (const item of inputList) {
      // Add item to the Map using label as key
      uniqueLabelsMap.set(item[labelKey], item);
    }

    // Convert Map values to array and return
    return Array.from(uniqueLabelsMap.values());
  }
}
